import React, {Component} from 'react';
import {connect} from 'react-redux';

import {Field, reduxForm, formValueSelector} from 'redux-form';
import {FormFieldHelpers as Form} from '../../../helpers';

class SingleInputForm extends Component {

  render() {

    const {handleSubmit, pristine} = this.props;
    return (
      <div className="theme-save-search">
        <form onSubmit={ handleSubmit } className="save-form">
          <p className="body-copy">Save search as...</p>
          <div className="form-group">
            <Field
              label="Name your search as..."
              name="single_input"
              placeholder="Non Executive Director"
              component={ Form.textFieldTwo  }
            />
          </div>
          <button className="theme-button" disabled={pristine}>
            Save search
          </button>
        </form>
      </div>

    );
  };
}

SingleInputForm = reduxForm({form: 'single_input_form'})(SingleInputForm);

const valueSelector = formValueSelector('single_input_form');

const mapStateToProps = (state) => {
  return {
    selectedInput: valueSelector(state, 'single_input'),
    formValues: state.form.single_input_form
  };
};

export default connect(mapStateToProps, null)(SingleInputForm);


// WEBPACK FOOTER //
// src/client/components/common/elements/SingleInputForm.js